function TodosError() {
    return (
        <p> Ocurrió un error! </p>
    );
}

export { TodosError };